import { FaRegCheckCircle, FaRegCircle, FaTrash } from "react-icons/fa";
import Rating from "@presentation/shared/components/rating/Rating";
import { T } from "@config/lang";
import { priceEuro } from "@presentation/shared/utils/price-format";
import * as React from "react";
import { WishListItem } from "@agent/context/wish-list";

type Props = {
  items: WishListItem[];
  selected: string[];
  toggleSelected(hash: string): void;
  removeFromWishList(hash: string): void;
};

export function WishListItems({
  items,
  selected,
  toggleSelected,
  removeFromWishList,
}: Props) {
  return (
    <tbody>
      {items.map((wish) => {
        const isSelected = selected.includes(wish.hash);
        return (
          <tr>
            <td className="p-2">
              <span
                className="text-blue-400 hover:text-red-600 cursor-pointer text-xl"
                onClick={() => toggleSelected(wish.hash)}
              >
                {isSelected ? <FaRegCheckCircle /> : <FaRegCircle />}
              </span>
            </td>
            <td width="130" valign="top" className="p-2">
              <img
                src={wish.image}
                alt={wish.name}
                width="120"
                className="rounded-[6px] block"
              />
            </td>

            <td valign="top" className="p-2 pl-[15px]">
              <h3 className="m-0 font-bold text-base">
                {wish.name} <Rating value={wish.category} />
              </h3>

              <p className="my-1 text-sm">{wish.location}</p>

              <p className="my-1 text-sm">
                {wish.room}, {wish.room_type}, {wish.board}
              </p>

              {wish.departure && wish.return ? (
                <p className="my-1 text-sm">
                  {T.results.departure}: {wish.departure} → {T.results.return}:{" "}
                  {wish.return}
                </p>
              ) : (
                <p className="my-1 text-sm">
                  {T.results.check_in}: {wish.checkin} → {T.results.check_out}:{" "}
                  {wish.checkout}
                </p>
              )}
            </td>

            <td valign="top" className="p-2 pl-[15px]">
              <h3 className="m-0 mb-2 font-bold text-base">
                <span className="whitespace-nowrap">
                  {wish.adl === 1
                    ? `1 ${T.search.adult}`
                    : `${wish.adl} ${T.search.adults}`}
                </span>
                {wish.chd > 0 && (
                  <>
                    <span className="whitespace-nowrap mr-1 ml-0.5">,</span>
                    <span className="whitespace-nowrap">
                      {wish.chd === 1
                        ? `1 ${T.search.child}`
                        : `${wish.chd} ${T.search.children}`}
                    </span>
                  </>
                )}
              </h3>

              <p className="my-2 font-bold">{priceEuro(wish.price)}</p>
            </td>

            <td className="p-2">
              <span
                className="text-gray-400 hover:text-red-600 cursor-pointer text-lg"
                onClick={() => removeFromWishList(wish.hash)}
              >
                <FaTrash />
              </span>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
}
